export default function Camera(props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_3295_3367)">
                <path
                    d="M8.25 39C7.00736 39 6 37.9926 6 36.75V16.25C6 15.0074 7.00736 14 8.25 14H15.8182L18.6468 9.67851C18.9239 9.25513 19.3958 9 19.9018 9H28.0982C28.6042 9 29.0761 9.25513 29.3532 9.67851L32.1818 14H39.75C40.9926 14 42 15.0074 42 16.25V36.75C42 37.9926 40.9926 39 39.75 39H8.25Z"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="36" cy="19.5" r="0.75" fill="black" stroke="white" strokeWidth="1.5" />
                <path
                    d="M24 33C28.1423 33 31.5 29.6423 31.5 25.5C31.5 21.3577 28.1423 18 24 18C19.8577 18 16.5 21.3577 16.5 25.5C16.5 29.6423 19.8577 33 24 33Z"
                    stroke="white"
                    strokeWidth="2.25"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_3295_3367">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
